var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51109 13.3544C8.24003 13.6081 7.87774 13.75 7.5007 13.75C7.12365 13.75 6.76136 13.6081 6.49031 13.3544C4.00814 11.0162 0.681727 8.40432 2.30392 4.61229C3.18102 2.56197 5.28646 1.25 7.5007 1.25C9.71493 1.25 11.8204 2.56197 12.6975 4.61229C14.3176 8.39954 10.9994 11.0243 8.51109 13.3544Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 6.875C9.6875 8.08312 8.70812 9.0625 7.5 9.0625C6.29188 9.0625 5.3125 8.08312 5.3125 6.875C5.3125 5.66688 6.29188 4.6875 7.5 4.6875C8.70812 4.6875 9.6875 5.66688 9.6875 6.875Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMeetings);
export default __webpack_public_path__ + "static/media/LocationMeetings.dcf1c44aeb105c97182bd35307c05a9b.svg";
export { ForwardRef as ReactComponent };